import { render, staticRenderFns } from "./AccessOs.vue?vue&type=template&id=0f8dbaef&"
import script from "./AccessOs.vue?vue&type=script&lang=js&"
export * from "./AccessOs.vue?vue&type=script&lang=js&"
import style0 from "./AccessOs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports